export const invoiceTemplateTesVars = {
    customer: {
        name: "Summer"
    },
    number: 2043,
    amountDue: 10000,
    paymentsMade: [
        {
            amount: 1000,
            method: "cash",
            date: new Date()
        },
        {
            amount: 2000,
            method: "bank-transfer",
            date: new Date()
        }
    ]   
}